var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-default"},[(_vm.title)?_c('div',{staticClass:"panel-heading"},[_c('div',{staticClass:"panel-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]):_vm._e(),_c('div',{staticClass:"panel-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }